import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import {
    ThemeProvider,
    createTheme,
} from '@mui/material';

import {
    green,
    blueGrey,
    grey,
} from '@mui/material/colors';

import {
    GoogleOAuthProvider,
} from '@react-oauth/google';

import {
    AdapterDayjs,
} from '@mui/x-date-pickers/AdapterDayjs';

import {
    LocalizationProvider,
} from '@mui/x-date-pickers/LocalizationProvider';

const root_node = document.getElementById('root');
const root = ReactDOM.createRoot(root_node);

const theme = createTheme({
    'palette': {
        'primary': green,
        'secondary': {
            'main': blueGrey[600],
            'light': grey[300],
            'dark': grey[800],
        },
    },
});

root.render(<React.StrictMode>
    <LocalizationProvider dateAdapter={ AdapterDayjs }>
        <GoogleOAuthProvider clientId={ process.env.REACT_APP_GOOGLE_CLIENT_ID }>
            <ThemeProvider theme={ theme }>
                <App innovation_email={ process.env.REACT_APP_INNOVATION_EMAIL }/>
            </ThemeProvider>
        </GoogleOAuthProvider>
    </LocalizationProvider>
</React.StrictMode>);
